
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Motivation`}</h2>
    <p><strong parentName="p">{`styled-components is the result of wondering how we could enhance CSS for styling React component systems.`}</strong>{` By focusing on a single use case we managed to optimize the experience for developers as well as the output for end users.`}</p>
    <p>{`Apart from the improved experience for developers, styled-components provides:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Automatic critical CSS`}</strong>{`: styled-components keeps track of which components are rendered on a page and injects their styles and nothing else, fully automatically. Combined with code splitting, this means your users load the least amount of code necessary.`}</li>
      <li parentName="ul"><strong parentName="li">{`No class name bugs`}</strong>{`: styled-components generates unique class names for your styles. You never have to worry about duplication, overlap or misspellings.`}</li>
      <li parentName="ul"><strong parentName="li">{`Easier deletion of CSS`}</strong>{`: it can be hard to know whether a class name is used somewhere in your codebase. styled-components makes it obvious, as every bit of styling is tied to a specific component. If the component is unused (which tooling can detect) and gets deleted, all its styles get deleted with it.`}</li>
      <li parentName="ul"><strong parentName="li">{`Simple dynamic styling`}</strong>{`: adapting the styling of a component based on its props or a global theme is simple and intuitive without having to manually manage dozens of classes.`}</li>
      <li parentName="ul"><strong parentName="li">{`Painless maintenance`}</strong>{`: you never have to hunt across different files to find the styling affecting your component, so maintenance is a piece of cake no matter how big your codebase is.`}</li>
      <li parentName="ul"><strong parentName="li">{`Automatic vendor prefixing`}</strong>{`: write your CSS to the current standard and let styled-components handle the rest.`}</li>
    </ul>
    <p>{`You get all of these benefits while still writing the CSS you know and love, just bound to individual components.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;